import Vue from 'vue'
import Router from 'vue-router'
import Layout from './../views/layout/layout'

Vue.use(Router)

// 路由懒加载
const _import = file => () => import('@/views/' + file)

export const routerMap = [
  {path: '/', redirect: '/article'},
  {path: '/404', component: _import('404/404')},
  {path: '/401', component: _import('401/401')},
  {
    path: '/article',
    name: '首页',
    component: Layout,
    redirect: '/article/list',
    children: [
      {path: 'list', name: '文章列表', component: _import('article/list')},
      {path: 'add', name: '新增文章', component: _import('article/add')},
      {path: 'edit', name: '编辑文章', component: _import('article/edit')},
      {path: 'preview', name: '预览文章', component: _import('article/preview')}
    ]
  },
  {path: '*', redirect: '/404'}
]

export default new Router({
  mode: 'history',
  routes: routerMap
})



// WEBPACK FOOTER //
// ./src/router/index.js